import Vue from 'vue'
import Router from 'vue-router'
import route from '@/routes/route'

Vue.use(Router)
export default new Router({
  mode: 'history', 
  routes: [
    ...route
    ,
    {
      path:'/Import',
      name:'Import',
      component: resolve => require(['@/views/order/goodsOnput/Import.vue'], resolve),
    }
  ]
})